<template>
   <van-popup v-model:show="show" @click-overlay="() => playClickSound()" position="left" @opened="resetScroll"
      ref="sidebarRef" :style="{ minHeight: '100%', width: '70%', zIndex: '10002', padding: '0px 0px' }">
      <van-row class="navBar" justify="space-around">
         <van-col span="3" @click="closeSidebar" class="header_item_menu">
            <van-icon name="cross" color="#fff" size="15" />
         </van-col>
         <van-col span="17" class="header_item_logo">
            <img src="@/assets/themeFour/logo.png" alt="">
         </van-col>
         <van-col span="2" class="header_item_menu">
            <img src="@/assets/themeFour/caller.png" alt="" width="90%" style="padding-right: 10px;"
               @click="openContactPopup">
         </van-col>
         <van-col v-if="userStore.loginAccount" style="display: flex; padding-top: 15px;" span="14" align="left">
            <!-- user balance -->
            <img src="@/assets/themeFour/cash.png" alt="" width="30%">
            <div class="header_button_item">
               <div class="coin_btn">
                  <div style="padding-left: 10px;"><span style="">R$ </span>{{ formatCurrency(balance) }}</div>
               </div>
               <div class="balanceText">{{ $t('home.balance') }}</div>
            </div>

         </van-col>
         <van-col v-if="userStore.loginAccount" span="8" class="btnContainer">
            <img src="@/assets/themeFour/btn1.png" @click="onButtonClick()" alt="" width="100%">
            <div @click="onButtonClick()" class="depositBtn">{{ $t('common.deposite') }}</div>
         </van-col>
         <van-col v-if="!userStore.loginAccount" span="24" class="header_button_item" align="center">
            <van-row style="width: 80%; padding: 15px 10%;">
               <van-col span="11" class="btnContainer">
                  <img @click="openRegisterPopup(1)" src="@/assets/themeFour/btn2.png" alt="" width="100%"
                     height="100%">
                  <div class="depositBtn" @click="openRegisterPopup(1)">{{ $t('common.login') }}</div>
               </van-col>

               <van-col span="12" offset="1" class="btnContainer">
                  <img @click="openRegisterPopup(0)" src="@/assets/themeFour/btn1.png" alt="" height="100%"
                     width="100%">
                  <div class="depositBtn" @click="openRegisterPopup(0)">{{ $t('common.register') }}</div>
               </van-col>
            </van-row>
         </van-col>
      </van-row>
      <div v-if="gameStore.hotGames && gameStore.hotGames?.length > 0" class="populargamesCard">
         <div class="headTitle">
            <img src="@/assets/themeThree/POPULAR_on.png" alt="" width="15%" height="100%">
            <div class="titleText">{{ $t('games.popular') }}</div>
         </div>
         <div class="balanceText">{{ $t('home.selectionGame') }}</div>
         <div class="gameContainer" ref="gameScrollRef">
            <div v-for="(item, index) in hotGames" :key="index" class="gameCard">
               <img :src="item.customIcon" alt="" width="25%"
                  @click="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)">
            </div>
         </div>
      </div>
      <div>
         <van-row class="activity_list" align="center">
            <van-col span="11" v-for="(item, index) in menuList" :key="index" @click="menuClick(item.name)"
               class="activityRow">
               <div class="icon-wrapper">
                  <img src="@/assets/themeFour/l1.png" alt="" width="40" />
                  <img class="icon-Image" :src="item.activity_icon" alt="" />
               </div>

               <div class="activityName">{{ t(`activityName.${item.name}`) }}</div>
            </van-col>
         </van-row>
      </div>
      <div class="groupList">
         <van-row class="game_list" v-for="(item) in props.listGameData" :key="item.id" @click="goToGamePannel(item)"
            align="center">
            <van-col span="4" class="game_img_col">
               <img class="game_icon" :src="item.customIcon" alt="" />
            </van-col>
            <van-col span="20" class="game_img_col">
               <div>{{ $t(item.name) }}</div>
            </van-col>
         </van-row>
      </div>


      <div class="share_content">
         <div class="shareTitle">{{ $t('message.support') }} Online.</div>
         <div style="display: flex;">
            <div class="share_item" v-for="(item, index) in shareList" :key="index">
               <img v-if="item.display" :src="item.url" alt="" @click="goToShare">
            </div>
         </div>
      </div>
   </van-popup>
   <!-- <PwaAntiBlockingPopup ref="pwaPopupRef" />
   <PwaStatusPopup ref="pwaPopupStatusRef" /> -->
</template>

<script setup lang="ts">
import { computed, inject, nextTick, ref, } from 'vue'
import { useRouter } from 'vue-router'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import { handleMenuClick, SideMenuListItem, goToShare, SHARE_LIST } from '@/view/components/supportFunction'
import { formatCurrency } from '@/utils/commonFunction';
import { useGameStore } from '@/stores/games';
import { goToPlayGame } from '@/view/home/supportScript';
const props = defineProps<{
   listGameData: Array<{
      name: string,
      customIcon: string,
      id: number | string,
   }>
}>()
const activityStore = useActivityStore()
const userStore = useUserStore()
const gameStore = useGameStore()
const { t } = useI18n();
const show = ref(false)
const router = useRouter()
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const isRotating = ref(false);
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()
const emits = defineEmits(['intallPWA', 'openContactPopup', 'goToGamePanelSlide', 'openPWA'])
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const componetList = ref(localStorage.getItem('componetList') || '')
const balance = computed(() => userStore.balance)
const shareList = ref(JSON.parse(componetList.value).find((item: any) => item.component_name == "shareMedia").shareMediaList)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const hotGames = computed(() => gameStore.hotGames)
const gameScrollRef = ref<HTMLElement | null>(null);
const goToGamePannel = (data: any) => {
   show.value = false
   emits('goToGamePanelSlide', data)
}
const openContactPopup = () => {
   emits('openContactPopup')
}
const openRegisterPopup = (type: number) => {
   openRegisterLoginPopup?.(type)
}
const sidebarRef = ref<any>(null);

const resetScroll = () => {
   if (sidebarRef.value?.$el) {
      sidebarRef.value.$el.scrollTop = 0;
   }

   const popupEl = document.querySelector('.van-popup--left');
   if (popupEl) {
      popupEl.scrollTop = 0;
   }
};
const openSidebar = async () => {
   show.value = true
   await nextTick();

   if (gameScrollRef.value) {
      gameScrollRef.value.scrollLeft = 0;
   }
}

const closeSidebar = () => {
   if (isRotating.value) return;
   isRotating.value = true;

   setTimeout(() => {
      show.value = false;
   }, 200);

   setTimeout(() => {
      isRotating.value = false;
   }, 1000);
}

const menuClick = (name: any) => {
   if(name === 'pwa_reward'){
      emits('openPWA')    
   }
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
   goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const onButtonClick = () => {
   router.push({ path: '/sd-topup' });
   localStorage.setItem('showDepositBackIcon', '1')
}
defineExpose({
   openSidebar,
   closeSidebar
})

</script>
<style scoped>
.navBar {
   z-index: 2000;
   padding: 10px 5px 5px;
   background: rgb(0, 53, 52);
   position: sticky;
   top: 0;
}

.header_item_menu {
   display: flex;
   align-items: center;
   justify-content: center;
}

.header_item_logo img {
   width: 90%;
}

.header_button_item {
   padding-right: 10px;
   display: flex;
   justify-content: center;
   flex-direction: column;
}

.coin_btn {
   display: flex;
   justify-content: right;
   flex-direction: column;
   color: #fff;
   font-size: 17px;
   font-weight: 700;
   border-radius: 20px;
   margin-right: 1px;
   white-space: nowrap;
   overflow: hidden;
}


.coin_btn div {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   flex: 1;
}

.balanceText {
   color: rgba(255, 255, 255, 0.60);
   padding: 10px;
   font-size: 15px;
}

.gameContainer {
   display: flex;
   overflow-x: auto;
   scrollbar-width: none;
}

.gameContainer::-webkit-scrollbar {
   display: none;
}

.gameCard {
   border-radius: 10px;
   margin-left: 5px;
   width: 75px;
   flex-shrink: 0;
   transform: skewX(-10deg);
   overflow: hidden;
   background: rgba(0, 0, 0, 0.1);
}

.gameCard img {
   width: 100%;
   height: 100%;
   object-fit: cover;
}

.btnContainer {
   position: relative;
   display: flex;
   align-items: center;
   justify-content: center;
   padding-top: 15px;
}

.depositBtn {
   position: absolute;
   top: 0%;
   padding-top: 2%;
   font-size: 18px;
   font-weight: 600;
   color: #fff;
   display: flex;
   align-items: center;
   height: 100%;
}

.registerLoginBtn {
   position: absolute;
   top: 0;
   height: 100%;
   padding-top: 2%;
   font-size: 20px;
   font-weight: 600;
   color: #fff;
   align-items: center;
}

.registerLoginBtn:hover {
   background: rgba(255, 255, 255, 0.082);
}

.navBar_menu {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 8px;
}

.navBar_menu img {
   width: 50px;
}

.navBar_logo {
   display: flex;
   align-items: center;
   justify-content: right;
   padding: 5px 0;
}

.navBar_logo img {
   width: 120px;
}

.navNotice img {
   width: 100%;
}

.van-popup {
   background: rgb(0, 53, 52);
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
   padding: 0 15px;
}

.van-popup::-webkit-scrollbar {
   display: none;
}

.infoContainer {
   background: #312734;
   border-radius: 10px;
   margin-top: 10px;
   padding: 10px;
}

.button_group {
   display: flex;
   justify-content: center;
   padding: 5px 0 0;
}

.btn_grid {
   padding: 4px;
}

.van-overlay {
   backdrop-filter: blur(5px);
   -webkit-backdrop-filter: blur(5px);
   z-index: 10001 !important;
}


.menu_list {
   padding: 12px 0;
   position: relative;
}

.menu_row {
   padding: 0 5%;
}

.menu_icon {
   width: 100%;
   margin-bottom: 10px;
}

.menu_grid_item {
   color: rgba(255, 255, 255, 0.45);
   box-sizing: border-box;
   border-radius: 10px;
}

.menu_item_inner {
   background-image: linear-gradient(180deg, rgb(129 54 94 / 12%) 0%, rgb(249 65 201 / 36%) 100%);
   border: 1.5px solid #daa6cf66;
   margin: 5px;
   border-radius: 10px;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 5px;
}

.menu_item_icon {
   width: 70%;
   object-fit: contain;
   padding: 10px;
   border-radius: 5px;
}

.menu_item_text {
   font-size: 12px;
   text-align: center;
   color: #ffffff;
}

.populargamesCard {
   border-radius: 10px;
   border-top: 2px solid rgb(245, 200, 76);
   background: rgb(0, 86, 85);
   padding: 15px;
   margin: 15px 10px;
}

.headTitle {
   display: flex;
   align-items: center;
}

.titleText {
   font-size: 20px;
   color: #ffffff;
   padding: 0px 15px;
   font-weight: 700;
}

.groupList {
   padding: 10px;
}

.activity_list {
   color: #fff;
   padding: 10px;
   font-size: 16px;
   position: relative;
   cursor: pointer;
   border-top: 1px solid rgb(0, 97, 95);
   border-bottom: 1px solid rgb(0, 97, 95);
}

.icon-wrapper {
   position: relative;
}

.icon-Image {
   position: absolute;
   width: 22px;
   height: 22px;
   top: 10px;
   left: 10px
}

.activityRow {
   display: flex;
   align-items: center;
   margin: 5px;
}

.activityName {
   background: rgb(0, 97, 95);
   padding: 3px;
   width: 100%;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   border-radius: 0 5px 5px 0;
   font-size: 16px;
   margin-left: -25px;
   padding-left: 30px;
   font-weight: 400;
   color: rgba(255, 255, 255, 0.5);
   line-height: 25px;
}

.game_list {
   background: rgb(0, 97, 95);
   border-radius: 10px;
   color: rgba(255, 255, 255, 0.4);
   padding: 10px;
   font-size: 18px;
   font-weight: bold;
   margin: 10px 0;
   position: relative;
   cursor: pointer;
  min-height: 5vh;
}

.share_content {
   position: sticky;
   bottom: 0;
   left: 0;
   right: 0;
   border-top: 1px solid rgb(0, 97, 95);
   background: rgb(0, 53, 52);
   padding: 5px 10px 20px;
   display: flex;
   justify-content: center;
   flex-direction: column;
   align-items: center;

}

.shareTitle {
   color: #fff;
   font-size: 20px;
   font-weight: 500;
   padding: 10px;
}


.share_item img {
   width: 35px;
   height: 35px;
   margin: 5px;
}

.game_img_col {
   display: flex;
   justify-content: left;
   align-items: center;
}

.game_icon {
   width: 80%;
   /* height: 25px; */
}

.game_name {
   font-size: 15px;
   color: #fff;
   margin-left: 10px;
}


.menu_img img {
   width: 25px;
}

.menu_text {
   color: #FFFFFF;
   font-size: 15px;
   font-weight: 400;
}

.menus {
   padding: 7.5px 0;
   position: relative;
}

.menu_icon_img {
   position: absolute;
   bottom: 0;
   right: 0;
   width: 82px;
   height: auto;
}


.user_info {
   color: rgba(255, 255, 255, 0.45);
}

.user_avatar img {
   width: 100%;
   border-radius: 10px;
}

.user_account {
   color: #fff;
   font-size: 4.2vw;
   padding-top: 5px;
   padding-left: 5px;
}

.user_ID {
   color: #fff;
   padding-top: 5px;
   padding-left: 5px;
   display: flex;
   align-items: end;
   font-size: 4.2vw;
}

.user_ID img {
   width: 20px;
   padding-left: 5px;
}

:deep(.van-icon) {
   display: inline-block !important;
}

@media (min-width: 450px) {
   .user_avatar img {
      width: 45px;
   }

   .user_account {
      font-size: 15px;
   }

   .van-popup {
      width: 70% !important;
   }
}

@media (max-width: 450px) {
   .groupList {
      padding: 5px;
   }

   .game_list {
      margin: 10px;
      font-size: 13px;
      min-height: 4vh;
   }

   .reportBtn {
      font-size: 13px;
   }

   .depositBtn {
      font-size: 16px;
   }

   .coin_btn {
      font-size: 13px;
   }

   .balanceText {
      padding: 5px 10px;
      font-size: 14px;
   }

   .titleText {
      font-size: 18px;
   }

   .activityRow {
      margin: 4px;
   }

   .activityName {
      font-size: 14px;
   }
}

.btn_grid .btn_text {
   font-size: 1px !important;
}
</style>